import { formatDateUTC } from "./user";


export const reciepentColumn = [
    { label: "client_code", attr: "client_code", type: 1 },
    { label: "email", attr: "email", type: 1 },
    // {
    //     label: "ppt_inn", attr: "ppt_inn", type: 1,
    //     editor: true
    // },
    {
        label: "first_name", attr: "first_name", type: 1,
        editor: true
    },
    {
        label: "last_name", attr: "last_name", type: 1,
        editor: true
    },
    {
        label: "created_date",
        attr: "created_date",
        type: 4,
        editor: true,
        body: (rowData) => formatDateUTC(rowData.created_date)
    },
    {
        label: "address", attr: "address", type: 1,
        editor: true
    }


];